<script>
import simplebar from "simplebar-vue";
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";
import VueEasyLightbox from "vue-easy-lightbox";
import axios from "axios";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
//import {ImageEditor} from '@toast-ui/vue-image-editor';
/**
 * Screenshot Component
 */

export default {
  page: {
    title: "Screenshot",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    VueEasyLightbox,
    //'tui-image-editor': ImageEditor,
    Multiselect,
    Layout,
    PageHeader,
    simplebar,
    DatePicker,
    
  },
  data() {
    return {
      loginData : {},
      empLoader: false,
      proMap: new Map(),
      markSensitiveModal: false,
      curr:{
        empId: null,
      },
      empChanged: false,
      employees: [],
      title: "Screenshot",
      ssDate: "",
      countDown: 10,
      disabledEvent : false,
      isLiveScreenshotDisabled: false,
      selectedDate: null,
      visible: false,
      singleImage: false,
      visibleCaption: false,
      index: 0, // default: 0
      loader: true,
      firstTimeLoader: true,
      filterValue: "",
      imgFilters: {
        start: null,
        end: null,
        project: null,
        sensitive: false,
        onlyOfficeHour: false,
      },
      markSensitiveComments: '',
      projectOptions: [
      ],
      times:[
      ],
      timeMinutes: [],
      imgs: [
      ],
      imgProjects:[
      ],
      imgCheckbox: [],
      captionimgs: [
        { src: require("@/assets/images/small/img-3.jpg"), title: "Caption 1" },
        { src: require("@/assets/images/small/img-7.jpg"), title: "Caption 2" },
      ],
      /*useDefaultUI: true,
      options: {
        cssMaxWidth: 700,
        cssMaxHeight: 500
      }*/
    };
  },
  methods: {
    onEmpSelect(data) {
        if(this.loader == true) {
            return;
       }
      this.imgFilters.start = null;
      this.imgFilters.end = null;
      this.imgFilters.project = null;
      this.imgs = [];
      this.empChanged = true;
      this.curr = data;
      
      var date = new Date(),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      this.ssDate = new Date();
      this.firstTimeLoader = true;
      this.loader = true;
      this.getScreenshots(4, 0);
    },
    clearFilters() {
      this.imgFilters.start =  null;
      this.imgFilters.end = null;
      this.imgFilters.project = null;
      this.imgFilters.sensitive = false;
      this.imgFilters.onlyOfficeHour =  false;
    },
    async getAllEmployees() {
      this.empLoader = true;
      try {
        let response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.employees = response.data.data;
            this.curr = this.employees[0];
            this.imgs = [];
            try {
              response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
              { params: { companyId: this.loginData.companyId } }
              );
              if(response.data.success == "true") {
                if(response.data.data.length > 0) {
                  let projects = response.data.data;
                  this.projects = projects;
                  projects.forEach(object => {
                    this.proMap.set(object.projectId, object);
                  });
                }
              }
            } catch (error) {
              //console.log(error);
            }
            this.getScreenshots(4, 0);
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.empLoader = false;
    },
    async getEmployees(emp) {
      this.empLoader = true;
      try {
        let response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.employees = response.data.data;
            if(emp) {
                this.curr = emp;
            } else {
              this.curr = this.employees[0];
            }
            this.imgs = [];
            try {
              response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
              { params: { companyId: this.loginData.companyId } }
              );
              if(response.data.success == "true") {
                if(response.data.data.length > 0) {
                  let projects = response.data.data;
                  this.projects = projects;
                  projects.forEach(object => {
                    this.proMap.set(object.projectId, object);
                  });
                }
              }
            } catch (error) {
              //console.log(error);
            }
            this.getScreenshots(4, 0);
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.empLoader = false;
    },
    async getAllProjects() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length;i++) {
              let p = {};
              p.value = this. response.data.data[i].projectId;
              p.text = this. response.data.data[i].projectName;
              this.projectOptions.push(p);
            }
            
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    onDateChange() {
       if(this.loader == true) {
            return;
       }
      if(this.ssDate != null){
        this.imgFilters.start = null;
        this.imgFilters.end = null;
        this.imgFilters.project = null;
        var date = new Date(this.ssDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        this.selectedDate = [date.getFullYear(), mnth, day].join("-");
        this.imgs = [];
        this.loader = true;
        this.firstTimeLoader = true;
        this.getScreenshots(4, 0);
      } else {
        this.selectedDate = "";
      }
    },
    liveScreenshot() {
      let formData = new FormData();
      formData.append("empId", this.curr.empId);
      axios
        .post(process.env.VUE_APP_EMPLOYEE_URL + `/employee/live_screenshot`, formData)
        .then((res) => {
          if(res.data.success == "true") {
            Swal.fire({
              title: "Screenshot Requested!",
              text: "Image will be available within 30 seconds in today's section.",
              icon: 'success',
              onClose: () => {
                this.isLiveScreenshotDisabled = true;
                this.countDownTimer();
                setTimeout(() => {
                      this.isLiveScreenshotDisabled = false;
                  }, 10000);
              }
            });
          } else {
            Vue.swal(res.data);
          }
        return res;
      })
      .catch((err) => {
        Vue.swal("Oops! Some error occured.");
        return err;
      });
    },
    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
    handleMarkSensitiveSubmit() {
      this.markSensitiveModal = false;
      let ischeckedSS = false;
      let sendData = [];

      for(var i = 0;i < this.imgs.length;i++) {
        if(this.imgs[i].isChecked == true) {
          ischeckedSS = true;
          let data = {};
          data.empId = this.curr.empId;
          data.timestamp = this.imgs[i].timestamp;
          sendData.push(data);
        }
      }
      if(ischeckedSS == false) {
        Vue.swal("Please Select Screenshot.");
        return;
      }

      let formData = new FormData();
      formData.append("companyId", this.loginData.companyId);
      formData.append("images", JSON.stringify(sendData));
      formData.append("comments", this.markSensitiveComments);

      axios
        .post(process.env.VUE_APP_SCREENSHOT_URL + `/screenshot/mark_sensitive`, formData)
        .then((res) => {
          if(res.data.success == "true") {
            Swal.fire({
              title: "Saved!",
              text: "Screenshots have been Marked Sensitive.",
              icon: 'success',
              onClose: () => {
                for(var i = 0;i < this.imgs.length;i++) {
                  if(this.imgs[i].isChecked == true) {
                    this.imgs[i].sensitive = 1;
                    this.imgs[i].isChecked = false;
                  }
                }
              }
            });
            
          } else {
            Vue.swal(res.data);
          }
          return res;
        })
        .catch((err) => {
          Vue.swal("Oops! Some Error Occured.");
          return err;
        });
    },
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
        }, 1000)
      } else {
        this.countDown = 10;
      }
    },
    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },
    handleCaptionHide() {
      this.visibleCaption = false;
    },
    nameWithLang({ text }) {
      return `${text}`;
    },
    downloadMultiple() {
      const zip = new JSZip();
      let text = this.$t('menuitems.screenshots.text');
      const img = zip.folder(text);
      for (var i = 0; i < this.imgs.length; i++) {
        img.file(this.curr.name + '_' + this.selectedDate + '_ss_' + this.imgs[i].time.substring(0,5) + '.png', this.imgs[i].src.split(',')[1], {base64: true});
      }
      zip.generateAsync({type:"blob"}).then(function(content) {
          saveAs(content, text + ".zip");
      });
    },
    /*async downloadImage() {
      axios({
        method: 'post',
        url: 'http://localhost:8085/screenshot/download',
        responseType: 'arraybuffer',
        data: ''
      }).then(function(response) {
        let blob = new Blob([response.data], { type: 'application/png' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'd1.png'
        link.click()
      })
    },*/
    async getScreenshots(limit, offset) {
      try {
        const response = await axios.get(
          process.env.VUE_APP_SCREENSHOT_URL + "/screenshot/get_images",
          { params: { companyId: this.loginData.companyId, empId: this.curr.empId, date: this.selectedDate, limit: limit, offset: offset,timezone: this.curr.timezone  } }
        );
        this.firstTimeLoader = false;
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length;i++){
              let img = {};
              img.time = response.data.data[i].time;
              let ts = response.data.data[i].time.split(":");
              img.timeMin = (parseInt(ts[0]) * 60) + parseInt(ts[1]);
              
              let p = {};
              console.log(response.data.data[i].projectId)
              if(response.data.data[i].projectId && this.proMap.get(response.data.data[i].projectId)) {
                p.value = response.data.data[i].projectId;
                p.text = this.proMap.get(response.data.data[i].projectId).projectName;
                img.project = p;
                
                let po = JSON.parse(JSON.stringify(p));
                var index = this.projectOptions.findIndex(x => x.value==po.value);

                if(index === -1 ) {
                  this.projectOptions.push(po);
                }
              } else {
                p.value = 0;
                p.text = '';
                img.project = p;
              }

              img.src = response.data.data[i].image;
              img.isChecked = false;
              img.sensitive = response.data.data[i].isSensitive;
              img.timestamp = response.data.data[i].timestamp;
              img.isDeleted = 0;
              this.imgs.push(img);
            }  
          }
          if(response.data.isMore == 1) {
              this.getScreenshots(limit, response.data.prevLimit+response.data.prevoffset, this.curr.timezone);
            } else {
              this.loader = false;
            }
        } else {
          this.loader = false;
        }

      } catch (error) {
        this.loader = false;
      }
    },
    confirm() {
      this.markSensitiveModal = false;
      let ischeckedSS = false;
      let sendData = [];

      for(var i = 0;i < this.imgs.length;i++) {
        if(this.imgs[i].isChecked == true) {
          ischeckedSS = true;
          let data = {};
          data.empId = this.curr.empId;
          data.timestamp = this.imgs[i].timestamp;
          sendData.push(data);
        }
      }
      if(ischeckedSS == false) {
        Vue.swal("Please Select Screenshot.");
        return;
      }
      Swal.fire({
          title: "Are you sure?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Yes, delete it!"
        }).then(result => {
          if(result.value) {
            let isPermanentDelete = 1;
            /*if (result.isConfirmed) {
              isPermanentDelete = 0;
            } else if(result.isDenied) {
              isPermanentDelete = 1;
            }*/
            let formData = new FormData();
            formData.append("images", JSON.stringify(sendData));
            formData.append("companyId", this.loginData.companyId);
            formData.append("isPermanentDelete", isPermanentDelete);

            axios
              .post(process.env.VUE_APP_SCREENSHOT_URL + `/screenshot/delete`, formData)
              .then((res) => {
                if(res.data.success == "true") {
                    Swal.fire("Deleted!", "Screenshot(s) have been deleted.", "success");
                    let temp = [];
                    for(i = 0;i < this.imgs.length;i++) {
                      if(this.imgs[i].isChecked == false) {
                        temp.push(this.imgs[i]);
                      }
                    }
                    this.imgs = temp;
                  } else {
                    Vue.swal(res.data);
                  }
                return res;
              })
              .catch((err) => {
                Vue.swal("Oops! Some Error Occured.");
                return err;
              });
          }
      });
    },
    /*cropMode() {
      const drawingMode = this.$refs.tuiImageEditor.invoke("getDrawingMode");
      console.log(drawingMode);
      this.$refs.tuiImageEditor.invoke('loadImageFromURL', 'img/img-1.3b232eb9.png', 'My sample image');

      this.$refs.tuiImageEditor.invoke('startDrawingMode', 'FREE_DRAWING', {
          width: 10,
          color: 'rgba(255, 0, 0, 0.5)'
      });
    },*/
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    if(this.$route.params.data) {
      if(this.$route.params.data.lastDate) {
        this.selectedDate = this.$route.params.data.lastDate;
        this.ssDate = new Date(this.selectedDate);
        this.getEmployees(this.$route.params.data);
      } else {
        var date = new Date(),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        this.selectedDate = [date.getFullYear(), mnth, day].join("-");
        this.ssDate = new Date(this.selectedDate);
        this.getEmployees(this.$route.params.data);
      }
    } else {
      date = new Date(),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      this.ssDate = new Date();
      this.getAllEmployees();
      //this.getAllProjects();
    }
  },

  mounted() {
    /*var container1 = document.querySelector(
      "#chat-list .simplebar-content-wrapper"
    );
    container1.scrollTo({ top: 500, behavior: "smooth" });

    var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 500, behavior: "smooth" });*/

    
  },
  
  computed: {
    searchevents: function(){
      var result = this.employees;
      if (!this.filterValue)
        return result;
      
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.name.toLowerCase().includes(filterValue) ||
          event.email.toLowerCase().includes(filterValue);
      return result.filter(filter);
    },
    searchImgEvents: function(){
      var result = this.imgs;
      if (!this.imgFilters.start && !this.imgFilters.end && !this.imgFilters.project && this.imgFilters.sensitive == false && this.imgFilters.onlyOfficeHour == false)
        return result;
      
      let starts = [0,0];
      if(this.imgFilters.start && this.imgFilters.start != null && this.imgFilters.start != '') {
        starts = this.imgFilters.start.split(":");
      }
      let ends = [23,59];
      if(this.imgFilters.end && this.imgFilters.end != null && this.imgFilters.end != '') {
        ends = this.imgFilters.end.split(":");
      }
      const sensitive = this.imgFilters.sensitive;
      const onlyOfficeHour = this.imgFilters.onlyOfficeHour;
      const start = (parseInt(starts[0]) * 60) + parseInt(starts[1]);
      const end = (parseInt(ends[0]) * 60) + parseInt(ends[1]);
      let project = null;
      if(this.imgFilters.project && this.imgFilters.project != null && this.imgFilters.project != '') {
        project = this.imgFilters.project;
      }
      const filter = event => {
          let val1 = true;
          let val2= true;
          if(onlyOfficeHour) {
            let st = this.curr.shiftStartTime.split(":");
            st = (parseInt(st[0]) * 60) + parseInt(st[1]);
            let et = this.curr.shiftEndTime.split(":");
            et = (parseInt(et[0]) * 60) + parseInt(et[1]);
            val1 = (event.timeMin >= st && event.timeMin <= et);
          }
          if(sensitive) {
            val2 = (event.sensitive == 1);
          }

          if(project) {
            return (event.timeMin >= start && event.timeMin <= end) && (event.project.value == project.value) && val1 && val2;
          }
          return (event.timeMin >= start && event.timeMin <= end) && val1 && val2;
      }
       //this.timeMinutes[this.imgs.indexOf(event)];
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.screenshots.text')" />
    <div class="row">
      <div class="col-xl-4">
      <div class="chat-leftsidebar me-lg-4">
        <div class="search-box py-4" style="width: calc(100% - 50px)">
          <div class="position-relative">
            <input type="text" class="form-control" :placeholder="$t('menuitems.screenshots.search')" v-model="filterValue"/>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>

        <div class="chat-leftsidebar-nav" style="width: calc(100% - 40px);">
          <div class="is-loading">
            <div class="preloader-componen" v-show="empLoader">
              <div class="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <b-card-text>
              <div>
                <div v-if="searchevents.length > 0">
                  <simplebar style="height: calc(100vh - 284px);" id="chat-list">
                    <ul class="list-unstyled chat-list">
                      <li
                        v-for="data of searchevents"
                        :key="data.empId"
                        @click="onEmpSelect(data)"
                        :class="{ active: curr.empId == data.empId }"
                      >
                        <a href="javascript: void(0);">
                          <div class="d-flex">
                            <div class="align-self-center me-3">
                              <i
                                :class="`mdi mdi-circle text-${data.color} font-size-10`"
                              ></i>
                            </div>
                            <div class="avatar-xs align-self-center me-3">
                              <span
                                class="
                                  avatar-title
                                  rounded-circle
                                  bg-soft bg-primary
                                  text-primary
                                "
                                >{{ data.name.charAt(0) }}</span
                              >
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                {{ data.name }}
                              </h5>
                              <p class="text-truncate mb-0">
                                {{ data.email }}
                              </p>
                            </div>
                            <!--<div class="font-size-11">{{ data.time }}</div>-->
                          </div>
                        </a>
                      </li>
                    </ul>
                  </simplebar>
                </div>
                <div v-if="searchevents.length <= 0">
                  <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 50%;margin-left: 22%;" height="180" width="180"><br />
                  <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
              </div>
              </div>
            </b-card-text>
          </div>
        </div>
      </div>
      </div>
       <div class="col-xl-8">
      <div class="card">
        
        <div class="card-body" style="height: calc(100vh - 222px);">
          <div class="row mb-1">
            <div class="col-md-8"><h3 class="card-title font-size-16">{{curr.name}}
              <b-dropdown
                variant="white"
                menu-class="dropdown-menu-end"
                dropright
              >
                <template v-slot:button-content>
                  <i class="bx bx-dots-vertical-rounded fs-2"></i>
                </template>
                <!--<b-dropdown-item>Take Live Screenshot</b-dropdown-item>-->
                <b-dropdown-item @click="markSensitiveModal = true">{{ $t('menuitems.screenshots.marksensitive') }}</b-dropdown-item>
                <b-dropdown-item @click="downloadMultiple">{{ $t('menuitems.screenshots.download') }}</b-dropdown-item>
                <!--<b-dropdown-item @click="downloadMultiple">Request Download Link</b-dropdown-item>-->
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="confirm">{{ $t('menuitems.screenshots.deleteScreenshots') }}</b-dropdown-item>
                <!--<b-dropdown-item>Erase Data</b-dropdown-item>-->
              </b-dropdown></h3>
            </div>
            <div class="col-md-1">
            <b-spinner
                class="m-2 col-md-1"
                v-show="!firstTimeLoader &&  loader"
                variant="primary"
                role="status"
              ></b-spinner>
            </div>
            <div class="col-md-3" v-if="loader">
              <date-picker
                v-model="ssDate"
                :first-day-of-week="1"
                lang="en"
                @change="onDateChange()"
                disabled
              ></date-picker>
            </div>
            <div class="col-md-3" v-else>
              <date-picker
                v-model="ssDate"
                :first-day-of-week="1"
                lang="en"
                @change="onDateChange()"
              ></date-picker>
            </div>
          </div>
          
          <div class="row mb-1">
            <div class="col-md-2"  style="margin-top: -7px;margin-left: -7px;">
              <b-dropdown dropleft variant="outline-secondary" class="m-2" checkbox-menu allow-focus>
                  <template #button-content>
                    <i class="bx bxs-filter-alt ps-2 pe-1"></i> <span class="pe-3">{{ $t('menuitems.screenshots.filters') }}</span>
                  </template>
                  <b-dropdown-form>
                    <b-form-checkbox
                        v-model="imgFilters.sensitive"
                        class="form-check mt-2 ms-2"
                        :disabled="loader"
                      >
                        {{ $t('menuitems.screenshots.sensitive') }}
                      </b-form-checkbox>
                    <b-form-checkbox
                        v-model="imgFilters.onlyOfficeHour"
                        class="form-check ms-2"
                        :disabled="loader"
                      >
                        {{ $t('menuitems.screenshots.officeHour') }}
                      </b-form-checkbox>
                  </b-dropdown-form>
              </b-dropdown>
            </div>
           
             <div class="col-md-3">
              <input
                type="time"
                class="form-control"
                v-model="imgFilters.start"
                :disabled="loader"
                id="stimepicker"
              />
            </div>
            <div class="col-md-3">
              <input
                type="time"
                class="form-control"
                v-model="imgFilters.end"
                :disabled="loader"
                id="etimepicker"
              />
            </div> 
            <div class="col-md-4">
              <multiselect
                v-model="imgFilters.project"
                :options="projectOptions"
                :custom-label="nameWithLang"
                :select-label="''"
                :deselectLabel="''"
                :disabled="loader"
                :placeholder="$t('menuitems.screenshots.selectProject')"
                track-by="text"
              ></multiselect>
            </div>
           </div>
           <div class="row">
             <div class="col-md-10"></div>
              <div class="col-md-2">
                <button type="button" @click="clearFilters" class="btn btn-link">Clear Filters</button>
            </div>
          </div>
          <!--<div class="col-md-6 mb-2"><button @click="liveScreenshot" v-show="curr.empId != null" :disabled="isLiveScreenshotDisabled" class="badge bg-success font-size-13 mt-2">Take Screenshot</button><span class="fs-6 text-danger" v-if="isLiveScreenshotDisabled"> Will be Active in {{countDown}} Seconds.</span></div>-->
          <div class="is-loading">
          <div class="preloader-component" v-show="firstTimeLoader">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          
          <simplebar  v-if="searchImgEvents.length > 0" style="height: calc(100vh - 400px);overflow-x: hidden;" >
            <div class="popup-gallery d-flex flex-wrap" >
                
                <div
                  v-for="(img, index) in searchImgEvents"
                  :key="index"
                  class="float-left pt-3 pe-3 me-2 mb-2"
                >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  name="select-all"
                  v-model="img.isChecked"
                />
                <span class="badge rounded-pill badge-soft-dark font-size-11 bg-gradient mb-1 me-2"
                    >{{searchImgEvents.length - index}}</span
                  >
                <span class="badge bg-secondary font-size-11 bg-gradient mb-1 me-2"
                    >{{img.time}}</span
                  >
                  <span v-if="img.sensitive == 1" class="badge badge-soft-warning font-size-11 bg-gradient mb-1"
                    >{{ $t('menuitems.screenshots.sensitive') }}</span
                  >
                  <a v-if="img.sensitive == 1" style="margin-left : 4px;" :href="img.src" :download="curr.name + '_' + selectedDate + '_ss_' + img.time.substring(0,5) + '.png'"><i class="bx bx-download fs-5 text-danger"></i></a>
                  <a v-if="img.sensitive == 0" style="margin-left : 60px;" :href="img.src" :download="curr.name + '_' + selectedDate + '_ss_' + img.time.substring(0,5) + '.png'"><i class="bx bx-download fs-5 text-danger"></i></a>
                  <br/>
                  <span v-if="img.project != null && img.project.text!= ''" >
                  <span style="max-width: 185px;" class="badge badge-soft-info font-size-11 bg-gradient  mb-1 text-truncate"
                    >{{img.project.text}}</span
                  ><br /></span>
                  <span v-else >
                  <span style="max-width: 185px;" class="badge badge-soft-primary font-size-11 bg-gradient  mb-1 text-truncate"
                    >{{ $t('menuitems.screenshots.noProject') }}</span
                  ><br /></span>
                  <img role="button" @click="() => showImg(index)" class="img-div" :src="img.src" width="190" style="filter: blur(-1px);"/>
                  
                </div>
              
            </div>
          </simplebar>
          <div v-if="searchImgEvents.length <= 0" style="margin-top: 19%;margin-left: 37%;">
                <img src="@/assets/images/no-data.png" alt="No Data" height="180" width="180"><br />
                <span class="mt-2 text-secondary fw-bold fs-3" >{{ $t('menuitems.screenshots.noImages') }}</span>
          </div>
          <vue-easy-lightbox
            :visible="visible"
            :imgs="searchImgEvents"
            :index="index"
            @hide="handleHide"
          >
          </vue-easy-lightbox>
          <!--<b-button @click="cropMode()">Toggle Crop Mode</b-button>
          <tui-image-editor ref="tuiImageEditor" :include-ui="useDefaultUI" :options="options"></tui-image-editor>-->
        </div>
      </div>
       </div>
      </div>
    </div>
    <b-modal v-model="markSensitiveModal" centered  :title="$t('menuitems.screenshots.marksensitive')" hide-footer>
      <form @submit.prevent="handleMarkSensitiveSubmit">
        <div class="row">
          <div class="col-12">
            <div class="form-group row mb-3">
              <label class="col-md-4 col-form-label" for="comments"
                >{{ $t('menuitems.screenshots.comments') }} <span class="text-secodary">({{ $t('menuitems.screenshots.ifAny') }})</span></label
              >
              <div class="col-md-8">
                <textarea
                  class="form-control"
                  v-model="markSensitiveComments"
                ></textarea>
              </div>
            </div>
            <div class="text-end mt-3">
              <b-button type="submit" variant="success" class="ms-1"
                >{{ $t('menuitems.screenshots.submit') }}</b-button
              >
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 18px;
  left: 30px;
  right: 0;
  bottom: 0;
  
  z-index: 999;
  width: 100%;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
}
.status {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
.imageEditorApp {
  width: 95vw;
  height: calc(100vh - 150px);
}
.disabled:hover {
  cursor: not-allowed;
}
#stimepicker:before {
content:'From';
margin-right:.6em;
color:#9d9d9d;
}
#etimepicker:before {
content:'To';
margin-right:.6em;
color:#9d9d9d;
}
</style>